import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import { mediaBreakpointDown } from '../../utils/styling';
import SolveIssueBanner from '../SolveIssueBanner';
import RecentPosts from '../RecentPosts';
// import CategoriesWidget from '../CategoriesWidget';
import RecentPostsSameCategory from '../RecentPostsSameCategory';
import TopPosts from '../TopPosts';
import { processPostSlug } from '../../utils/functions';

const SolveIssueContainer = styled.div`
  &::after {
	content: "";
	display: block;
	height: 50px;
	margin-top: -4px;
	background: linear-gradient(180deg, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0.00) 90%);
	@media (max-width: 991px) {
		display: none;
	}
  }

  &::before {
	content: "";
	display: block;
	height: 50px;
	margin-bottom: -4px;
	background: linear-gradient(0deg, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0.00) 90%);
	@media (max-width: 991px) {
		display: none;
	}
  }
	${mediaBreakpointDown('md')} {
	width: 370px;
	}
	${mediaBreakpointDown('xs')} {
	width: 100%;
	}
	top: 20px;
	position: sticky;
	@media (max-width: 991px) {
		position: unset;
		top: unset;
		margin-bottom: 20px;
	}
`;



const RecentPostContainer = styled.div`
`;

function PostSidebar({ dnpUrl, recentPosts = [], topPosts = [], category }) {
	const data = useStaticQuery(
		graphql`
			query postSideBar {
				cms {
					posts: wpPostsConnection(first: 5, sortByPublishedDateDesc: true, isRefundWebsite:true) {
						edges {
							node {
								id
								slug
								title
							}
						}
					}
					categories: wpCategoriesConnection(first: 12, isRefundWebsite:true, sortByNameAsc: true) {
						edges {
							node {
								id
								name
								slug
							}
						}
					}
				}
			}
		`,
	);

	topPosts = topPosts.map((post) => {
		console.log(post.node.slug);
		if (post?.node?.slug?.endsWith("-2"))  {
			post.node.slug = processPostSlug(post.node.slug)
		}
		return post
	});

	recentPosts = recentPosts.map((post) => {
		console.log(post.node.slug);
		if (post?.node?.slug?.endsWith("-2"))  {
			post.node.slug = processPostSlug(post.node.slug)
		}
		return post
	}
	);

	data.cms.posts.edges = data.cms.posts.edges.filter((post) => {
		if (post?.node?.slug?.endsWith("-2"))  {
			post.node.slug = processPostSlug(post.node.slug)
		}
		return post
	});
	return (
		<>
			{/* <SolveIssueContainer>
				<SolveIssueBanner url={dnpUrl} />
			</SolveIssueContainer> */}
			{topPosts.length > 0 && (
				<RecentPostContainer>
					<TopPosts topPosts={topPosts} />
				</RecentPostContainer>
			)}
			{recentPosts.length > 0 && (
				<RecentPostContainer>
					<RecentPostsSameCategory recentPosts={recentPosts} category={category} />
				</RecentPostContainer>
			)}
			<RecentPostContainer>
				<RecentPosts posts={data.cms.posts} />
			</RecentPostContainer>
		</>
	);
}

export default React.memo(PostSidebar);
